// @flow
import styled from '@emotion/styled';
import { SPACING } from '@tablekit/theme';
import { GRID_GUTTER } from 'utils/theme';

const BodyPadding = styled.div`
  margin: ${SPACING.L6} ${SPACING.L4} 0;

  @media (min-width: 576px) {
    margin: ${SPACING.L9} ${GRID_GUTTER} 0;
  }
`;

export default BodyPadding;
